import { BASIC_BRANCHENBUCH_AGENT, BRANCHENBUCH_AGENT } from '../models/AgentTypes';
export var isBasicBranchenbuchAgent = function isBasicBranchenbuchAgent(type) {
  return type === BASIC_BRANCHENBUCH_AGENT;
};
export var isBranchenbuchAgent = function isBranchenbuchAgent(type) {
  return type === BRANCHENBUCH_AGENT;
};